import { useEffect, useState } from 'react';

import { throttle } from 'lodash';
import { useSlate, useSlateStatic } from 'slate-react';

import { MIN_WORDS_FOR_AI_LAYOUT } from 'bundles/cml/editor/components/buttons/ai-layout/constants';
import { getWordCount, hasAILayoutElement } from 'bundles/cml/editor/components/buttons/ai-layout/utils';

const throttledWordCount = throttle(getWordCount, 300);

export const useAILayoutState = () => {
  const editor = useSlate();
  const staticEditor = useSlateStatic();
  const active = hasAILayoutElement(editor);

  const [disabled, setDisabled] = useState(false);
  const { selection } = editor;

  useEffect(() => {
    const shouldDisable = active || throttledWordCount(staticEditor) < MIN_WORDS_FOR_AI_LAYOUT;
    setDisabled(shouldDisable);
  }, [active, staticEditor, selection]);

  useEffect(() => {
    return () => throttledWordCount.cancel();
  }, []);

  return { active, disabled };
};
